import config from "../../Config";
import { useLanguage } from "../../i18n";

function Footer() {
    const { t } = useLanguage();
    return (
        <footer className="py-12 mt-16 border-t border-gray-100">
            <div className="max-w-6xl mx-auto px-5 flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-gray-500 text-sm">
                    &copy; {new Date().getFullYear()} {config.name}. {t('footer.rights')}
                </p>
                <p className="text-gray-500 text-sm">
                    {t('footer.builtWith')}
                </p>
            </div>
        </footer>
    );
}

export default Footer;
